import { useNavigate } from 'react-router-dom';
import { Users, ShoppingBag, Package } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { userUpdateViewType } from '../app/reducers/userInfo/slice';

const SelectView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Add this line

  const handleView = (role) => {
    dispatch(userUpdateViewType(role));
    if (role === 'brand') {
      navigate('/brand/products'); // Changed to /brand/products as per Login.jsx
    } else if (role === 'seller') {
      navigate('/seller/brand-catalog'); // Changed to /seller/brand-catalog as per Login.jsx
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center secondary-background px-4 login-container">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-md">
        <div className="text-center mb-6">
          <div className="h-20 w-20 mx-auto mb-6 secondary-background rounded-full flex items-center justify-center">
            <Users className="text-4xl text-primary" />
          </div>
          <h2 className="text-lg font-semibold text-primary mb-2">Choose between account types</h2>
          <p className="text-sm text-secondary mb-10">Please Select a Role to Continue</p>
        </div>

        <div className="flex justify-center gap-6 mb-4">
          <button
            className="w-1/3 primary-background white-text py-2 rounded-xl font-medium text-sm flex items-center justify-center gap-2"
            onClick={() => handleView('brand')}
          >
            <Package className="h-4 w-4" />
            Brand
          </button>
          <button
            className="w-1/3 primary-background white-text py-2 rounded-xl font-medium text-sm flex items-center justify-center gap-2"
            onClick={() => handleView('seller')}
          >
            <ShoppingBag className="h-4 w-4" />
            Seller
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectView;
